import {
    useCallback, useEffect, useMemo, useState,
} from "react";
import { useNavigate } from "react-router-dom";

const STORAGE_KEY = "tokenImpersonate";
const postCaptureRedirect = "/";

const useImpersonate = () => {
    const navigate = useNavigate();
    const initialFromStorage = useMemo(() => sessionStorage.getItem(STORAGE_KEY), []);

    const [token, setToken] = useState(initialFromStorage);

    const persistToken = useCallback(
        (next) => {
            if (next) {
                sessionStorage.setItem(STORAGE_KEY, next);
            } else {
                sessionStorage.removeItem(STORAGE_KEY);
            }
            setToken(next || null);
        },
        [],
    );

    useEffect(() => {
        const path = window.location.pathname || "";
        const query = window.location.search || "";

        const pathMatch = path.match(/^\/impersonate\/([^/?#]+)/);
        const queryMatch = new URLSearchParams(query).get("impersonate");

        const tokenFromUrl = decodeURIComponent(pathMatch?.[1] || queryMatch || "");

        if (tokenFromUrl) {
            persistToken(tokenFromUrl);
            navigate(postCaptureRedirect, { replace: true });
        }
    }, [navigate, persistToken]);

    const clearImpersonation = useCallback(() => {
        persistToken(null);
        navigate(postCaptureRedirect, { replace: true });
    }, [navigate, persistToken]);

    return { tokenImpersonate: token, clearImpersonation };
};

export default useImpersonate;
